import type { ReactNode } from "react";

interface ScenePhoneProps {
  x: number;
  y: number;
  rotate?: number;
  width: number;
  // Default 190 (industry hero scenes); taller phones pass their own.
  height?: number;
  // Screen content, drawn from the screen's top-left corner.
  children: ReactNode;
}

// The one small phone drawn inside SVG hero scenes (industry heroes, the QR
// hero): drop shadow, dark frame, white screen and a speaker slot.
const ScenePhone = ({
  x,
  y,
  rotate = 0,
  width,
  height = 190,
  children,
}: ScenePhoneProps) => (
  <g transform={`translate(${x} ${y}) rotate(${rotate})`}>
    <rect x="4" y="8" width={width} height={height} rx="22" className="fill-ink/15" />
    <rect x="0" y="0" width={width} height={height} rx="22" className="fill-ink" />
    <rect x="7" y="7" width={width - 14} height={height - 14} rx="16" className="fill-white" />
    <rect x={width / 2 - 22} y="12" width="44" height="7" rx="4" className="fill-ink" />
    <g transform="translate(7 7)">{children}</g>
  </g>
);

export default ScenePhone;
